<template>
    <div data-spm="report" data-spm-stop="init">
        <a class="report-c" :href="feedbackUrl" target="_blank">
            <img src="//statics.itc.cn/msfe/pictures/icon_report_empty_4@2x.png" class="img-default" />
            <img src="../images/icon_report_empty_default.png" class="img-hover" />
            <span class="report" style="text-decoration:underline">内容举报</span>
        </a>
    </div>
</template>
<script>
import { env } from "@/env"

export default {
    name: "report",
    data() {
        return {
            showFeedback: false,
            articleUrl: window.location.origin + window.location.pathname
        }
    },
    computed:{
        feedbackUrl(){
            const urlMap = {
                dev: `//beta.www.sohu.com/feedback?articleUrl=${this.articleUrl}&pageType=report`,
                test: `//beta.www.sohu.com/feedback?articleUrl=${this.articleUrl}&pageType=report`,
                pre: `//pre-www.sohu.com/feedback?articleUrl=${this.articleUrl}&pageType=report`,
                prod: `//www.sohu.com/feedback?articleUrl=${this.articleUrl}&pageType=report`
            }
            return urlMap[env]
        }
    }
};
</script>
<style lang="less" scoped>
.report-c {
    cursor: pointer;

    .img-hover {
        display: none;
    }

    &:hover {
        .img-hover {
            display: inline-block;
        }

        .img-default {
            display: none;
        }
    }

    .report {
        color: #606060;

        &:hover {
            color: #111;
        }
    }
}
</style>